import {
  IMAGE,
  ATTACHMENT,
  VIDEO,
} from 'hb-react/shared/components/DesignSystem/QuillEditor/constants';
import {
  ACCEPT_ATTACHMENTS,
  ACCEPT_IMAGES,
  ACCEPT_VIDEOS,
} from 'hb-react/shared/components/DesignSystem/QuillEditor/Toolbar';

// define a unique type for a group of files
// if at least one file is a video, return video
// if at least one file is an image, return image
// else if at least one file is an attachment, return attachment
export const defineFileType = (filesGroup) => {
  if (filesGroup.find((file) => ACCEPT_VIDEOS.includes(file.type))) {
    return VIDEO;
  }
  if (filesGroup.find((file) => ACCEPT_IMAGES.includes(file.type))) {
    return IMAGE;
  }
  if (filesGroup.find((file) => ACCEPT_ATTACHMENTS.includes(file.type))) {
    return ATTACHMENT;
  }
};
